<div class="db-tax-settings" [formGroup]="taxSettingsForm">
  <div>
    <div class="ds-input-wrap mb9">
      <div class="ds-input-label mb20" >
        <span [innerHTML]="basedOnSettings?.label"></span>
        <i class="db-icon db-icon-info-lined ml5"
           *ngIf="basedOnSettings?.tip"
           dsTooltipColor="black"
           [dsTooltip]="basedOnSettings?.tip"
           dsTooltipPosition="right"
           dsTooltipAlign="top"></i>
      </div>
      <ds-dropdown  [ngClass]="{'automated': !!connectTaxesEnabled}"
                    [dsDropdownDisabled]="!!connectTaxesEnabled"
                    [dsDropdownOptions]="basedOnSettings?.options" [value]="basedOnSettings?.value"
                    formControlName="basedOn"></ds-dropdown>
    </div>
    <div class="ds-input-wrap mb9">

      <div class="ds-input-label mb20" >
        <span [innerHTML]="shippingClassSettings?.label"></span>
        <i class="db-icon db-icon-info-lined ml5"
           *ngIf="shippingClassSettings?.tip"
           dsTooltipColor="black"
           [dsTooltip]="shippingClassSettings?.tip"
           dsTooltipPosition="right"
           dsTooltipAlign="top"></i>
      </div>
      <ds-dropdown [ngClass]="{'automated': !!connectTaxesEnabled}"
                   [dsDropdownOptions]="shippingClassSettings?.options"
                   [dsDropdownDisabled]="!!connectTaxesEnabled"
                   [value]="shippingClassSettings?.value || 'standard'"
                   formControlName="shippingClass"></ds-dropdown>
    </div>
  </div>

  <div class="mt30">
    <div class="ds-input-wrap">

      <div class="ds-input-label mb20" >
        <span [innerHTML]="taxTotalSettings?.label"></span>
        <i class="db-icon db-icon-info-lined ml5"
           *ngIf="taxTotalSettings?.tip"
           dsTooltipColor="black"
           [dsTooltip]="taxTotalSettings?.tip"
           dsTooltipPosition="right"
           dsTooltipAlign="top"></i>
      </div>
      <ds-dropdown [ngClass]="{'automated': !!connectTaxesEnabled}"
                   [dsDropdownOptions]="taxTotalSettings?.options"
                   [dsDropdownDisabled]="!!connectTaxesEnabled"
                   [value]="taxTotalSettings?.value"
                   formControlName="taxTotal"></ds-dropdown>
    </div>
    <div>
      <a class="ds-link" (click)="disableCalcTaxes()">{{ 'text_deactivateTaxCalculation' | dbText }}</a>
      <a class="ds-btn-black ml20"
         [ngClass]="{'ds-btn-disabled': !!loadingBtn || !!connectTaxesEnabled}"
         (click)="!connectTaxesEnabled && saveTaxSettings()">
        <span *ngIf="!loadingBtn">{{ 'text_saveButton' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="!!loadingBtn"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</div>
<db-loading-screen [pageBlocker]="true" *ngIf="!!loading"></db-loading-screen>
